import React from 'react'
import { Col, Row, Label } from 'reactstrap'
import FormValidator from '../FormValidation';
import CustomDatePicker from '../CustomDatePicker';
import ReportDateLabels from './reportDateLabels';

const isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);

let initialStartDate = 'Start Date';

export const validator = new FormValidator([
    { field: 'startDate', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
    { field: 'endDate', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
    { field: 'startDate', method: isBefore, validWhen: true, message: 'Start date must be before end date.' },
])

function DateRangePicker(props) {

    switch (props.fieldName) {
        case 'salesReport':
            initialStartDate = ReportDateLabels.SalesReport;
            break
        case 'enrolledGift':
            initialStartDate = ReportDateLabels.EnrolledGiftReport;
            break
        case 'contactUs':
            initialStartDate = ReportDateLabels.ContactUsSubmissionsReport;
            break
        case 'refundedGift':
            initialStartDate = ReportDateLabels.RefundedGiftReport;
            break
        case 'promoCode':
            initialStartDate = ReportDateLabels.PromoCodeUsageReport;
            break
        case 'redemptionCode':
            initialStartDate = ReportDateLabels.RedemptionCodeUsageReport;
            break
        case 'crossTerritorySalesReport':
            initialStartDate = ReportDateLabels.CrossTerritorySalesReport;
            break
        default:
            break
    }

    return <>
        <Col>
            <Row form>
                <Col>
                    <Label className="required-hint mt-4"><strong>{initialStartDate}</strong></Label>
                    <CustomDatePicker
                        id="startDate"
                        defValue={!props.startDate ? "" : props.startDate.substring(0, 10)}
                        label="Start Date"
                        overlayClass="location-datepicker-overlay"
                    />
                    <span className="help-block-calendar">{props.validation.startDate.message}</span>
                </Col>
                <Col>
                    <Label className="required-hint mt-4"><strong>End</strong></Label>
                    <CustomDatePicker
                        id="endDate"
                        defValue={!props.endDate ? "" : props.endDate.substring(0, 10)}
                        label="End Date"
                        overlayClass="location-datepicker-overlay"
                    />
                    <span className="help-block-calendar">{props.validation.endDate.message}</span>
                </Col>
            </Row>
        </Col>
    </>
}

export default DateRangePicker